import type { ReactNode } from "react";
import { AuthShowcase } from "./auth-showcase";
import { PublicLanguageMenu } from "../language";

/** Estrutura comum das telas de acesso, com controles LAI e painel responsivo. */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen bg-background [--control-height:2.75rem] [--control-padding:0.625rem]">
      <div className="relative flex w-full shrink-0 items-center justify-center px-6 py-16 lg:w-[40%] lg:min-w-[28rem]">
        <PublicLanguageMenu className="absolute top-3 right-3" />
        <div className="w-full max-w-[400px]">{children}</div>
      </div>
      <AuthShowcase />
    </div>
  );
}

export function AuthBrand() {
  return (
    <div className="flex items-center justify-center gap-2">
      <img src="/logo.svg" alt="" className="size-20" />
      <span className="text-2xl font-bold tracking-tight">Disk</span>
    </div>
  );
}
